import React from 'react'
import PropTypes from 'prop-types'

import Spinner from '../../sitewide/Spinner'
import ApptTypesContainer from './ApptTypesContainer'

const AppointmentTypes = ({
  apptTypeFetching,
  appointmentTypes,
  patchAppointmentType,
  hasPatientPortal,
}) => (
  <div>
    {apptTypeFetching && <Spinner />}
    <ApptTypesContainer
      appointmentTypes={appointmentTypes}
      patchAppointmentType={patchAppointmentType}
      hasPatientPortal={hasPatientPortal}
    />
  </div>
)

AppointmentTypes.propTypes = {
  appointmentTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      appointment_type_guid: PropTypes.string,
      practice_id: PropTypes.number,
      code: PropTypes.string,
      description: PropTypes.string,
      visibility: PropTypes.string,
      updated_at: PropTypes.string,
      created_at: PropTypes.string,
      online_scheduling: PropTypes.bool,
    }),
  ),
  apptTypeFetching: PropTypes.bool.isRequired,
  hasPatientPortal: PropTypes.bool.isRequired,
  patchAppointmentType: PropTypes.func.isRequired,
}

export default AppointmentTypes



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/index.js